<template>
    <div>
        <!-- 添加会员 对话框 -->
      <el-dialog title="添加会员"
          :visible.sync="addMember"
          width="424px"
          :before-close="handleDialogCloseAnoths"
          class="addMemberDialog">
      <el-form :inline="true"
          ref="ListForm"
          :model="addFormData"
          :rules="addFormDataRules"
          class="demo-form-inline">
          <el-form-item label="买家账号"
              label-width="100px"
              prop="pin">
			<el-input class="item-content"
				v-model="addFormData.pin"
				placeholder="请输入内容"
				maxlength="128">
			</el-input>
          </el-form-item>
          <el-form-item label="买家姓名"
              label-width="100px"
              prop="fullName">
			<el-input class="item-content"
				v-model="addFormData.fullName"
				placeholder="请输入内容"
				maxlength="256">
			</el-input>
          </el-form-item>
          <el-form-item label="手机号码"
              label-width="100px"
              prop="mobile">
			<el-input class="item-content"
				v-model="addFormData.mobile"
				placeholder="请输入内容"
				@change="checkNo(addFormData.mobile)"
				onkeypress="return event.keyCode>=48&&event.keyCode<=57"
				maxlength="64">
			</el-input>
          </el-form-item>
          <!-- <el-form-item label="性别"
              label-width="100px">
          <el-select class="item-content"
              style="width: 184px"
              v-model="addFormData.sex"
              placeholder="请选择">
              <el-option v-for="item in sex_all"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
          </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="生日"
                      label-width="100px">
          <el-date-picker v-model="addFormData.birthday"
                          type="date"
                          style="width: 184px"
                          placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="职业"
                      label-width="100px">
          <el-select class="item-content"
                      style="width: 184px"
                      v-model="addFormData.crowdPortraitType"
                      placeholder="请选择">
              <el-option v-for="item in worker_all"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="邮箱"
                      label-width="100px">
          <el-input class="item-content"
                      v-model="addFormData.email"
                      placeholder="请输入内容"
                      maxlength="128"></el-input>
          </el-form-item>
          <el-form-item label="QQ"
                      label-width="100px">
          <el-input class="item-content"
                      v-model="addFormData.qq"
                      placeholder="请输入内容"
                      type="text"
                      @change="checkNo(num)"
                      onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                      maxlength="16"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="微信"
                      label-width="100px">
          <el-input class="item-content"
                      v-model="addFormData.weChat"
                      placeholder="请输入内容"
                      maxlength="32"></el-input>
          </el-form-item> -->
          <el-form-item label="交易总额"
                      label-width="100px"
                      prop="buyTotalMoney">
          <el-input class="item-content"
                      v-model="addFormData.buyTotalMoney"
                      placeholder="请输入内容"
                      type="text"
                      @change="checkNo"
                      onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                      maxlength="15"></el-input> 元
          </el-form-item>
          <el-form-item label="购买次数"
                      label-width="100px"
                      prop="buyTotalCount">
          <el-input class="item-content"
                      v-model="addFormData.buyTotalCount"
                      placeholder="请输入内容"
                      type="text"
                      @change="checkNo"
                      onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                      maxlength="6"></el-input> 次
          </el-form-item>
          <!-- <el-form-item label="会员等级"
                      label-width="100px">
          <el-select class="item-content"
                      style="width: 184px"
                      v-model="addFormData.grade"
                      placeholder="请选择">
              <el-option v-for="item in memberUser_all"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"></el-option>
          </el-select>
          </el-form-item> -->
		  <el-form-item label="详情地址"
                      label-width="100px">
				<el-select v-model="addFormData.province" placeholder="请选择">
					<el-option
						v-for="item in province"
						:key="item"
						:label="item"
						:value="item">
					</el-option>
				</el-select>
          </el-form-item>
          <el-form-item label="详情地址"
                      label-width="100px"
                      prop="fullAddress">
          <el-input class="item-content"
                      v-model="addFormData.fullAddress"
                      placeholder="请输入内容"
                      maxlength="256"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAdd" class="cancel_Btn">取 消</el-button>
          <el-button type="primary" class="sure_Btn" @click="submitFormList('ListForm')">确 定</el-button>
      </span>
      </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'add-customer',
    props:{
    },
    data() {
      return {
        addMember: true,
		addFormData: {
            buyTotalCount: "",
            buyTotalMoney: "",
            pin: "",
            fullAddress: "",
            mobile: "",
			fullName: "",
			province: '',
        },
        addFormDataRules: {
            pin: [
              {
                  required: true,
                  message: "请输入买家昵称",
                  trigger: "blur"
              }
            ],
            fullName: [
              {
                  required: true,
                  message: "请输入姓名",
                  trigger: "blur"
              }
            ],
            mobile: [
              {
                  required: true,
                  message: "请输入手机号码",
                  trigger: "blur"
              }
            ],
		},
		province: [
			'全部', '广东省', '河北省', '山西省', '辽宁省', '黑龙江省', '江苏省', 
			'浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', 
			'湖南省', '海南省', '四川省', '贵州省', '云南省', '陕西省', '甘肃省', '青海省', '台湾省'
		]
      }
    },
    mounted() {

    },
    methods: {
       /**
     * 新增會員
     * @param formName
     */
      submitFormList(formName) {
        if (!this.isPhoneNum(this.addFormData.mobile)) {
          this.$message.warning("请输入正确的手机号");
          return;
        }
        let vm = this;

        vm.$refs[formName].validate(valid => {
          if (valid) {
            vm.$emit('addUserData', vm.addFormData)
          } else {
            return false;
          }
        });
      },

      checkNo(value) {
        console.log(value)
        let reg = /^[1-9]\d*$/;
        let min = 1;
        let max = 32;
        if (value) {
          if (value > 99999 || new RegExp(reg).test(value) == false) {
            setTimeout(() => {
              this.inputEleven = "";
            }, 500);
          }
        }
      },

      // 取消添加
      cancelAdd() {
        this.$emit('cancel')
      },

      handleDialogCloseAnoths() {
        this.$emit('cancel')
      }
    },
}
</script>

<style lang="scss" scoped>
.item-content{
  width: 184px;
}
.dialog-footer {
  justify-content: flex-end;
  margin: 0;
}
</style>